import Ads from 'src/components/ads';

import { ModifyAdsSlot } from 'src/components/ads/modify-ads';

import { KEY_DEVICE, useDevice } from 'src/utils/device';

// TODO :: ADS : Homepage
//      <DynamicAds type={KEY_ADS_TYPE.BILLBOARD} section= 'homepage' adsName= 'billboard' />
// TODO :: ADS : Category
//      <DynamicAds type={KEY_ADS_TYPE.STICKY} section={`${cid}`} adsName= {`sticky-${cid}`} />
// TODO :: ADS : Category ID
//      <DynamicAds type={KEY_ADS_TYPE.INARTICLE} section={`${_article?.section?.en}`} adsName= {`inarticle-${_article?.section?.en}-1`} />

/* -------------------------------- KEY_TYPE -------------------------------- */
export const KEY_ADS_TYPE = {
  BILLBOARD: 'billboard',
  STICKY: 'sticky',
  INARTICLE: 'inarticle',
  POSTARTICE: 'postartice'
};

/* -------------------------------------------------------------------------- */

const DynamicAds = (data) => {
  if (data?.section === 'undefined') return null;
  if (ModifyAdsSlot({ ...data }) === null) return null;

  //   console.log(data, ModifyAdsSlot({ ...data }), ModifyAdsSlot({ ...data })?.ads_platform);

  const checkSize = (type) => {
    const size = ModifyAdsSlot({ ...data })?.ads_size;
    switch (type) {
      case 'all':
        return useDevice(KEY_DEVICE.MOBILE) ? size.mobile : size.desktop;
      case 'mobile':
        return size.mobile;
      case 'desktop':
        return size.desktop;
      default:
        return null;
    }
  };

  switch (data.type) {
    case KEY_ADS_TYPE.POSTARTICE:
    case KEY_ADS_TYPE.BILLBOARD:
    case KEY_ADS_TYPE.INARTICLE:
    case KEY_ADS_TYPE.STICKY:
      return (
        <Ads
          adsClassName={`ads-${ModifyAdsSlot({ ...data })?.ads_name.split('-')[0]}`} // ads << default className css
          device={ModifyAdsSlot({ ...data })?.ads_platform}
          slot={ModifyAdsSlot({ ...data })?.ads_slot}
          position={ModifyAdsSlot({ ...data })?.ads_position}
          size={checkSize(ModifyAdsSlot({ ...data })?.ads_platform)}
        />
      );
    default:
      /* ------------------------------- Default Ads ------------------------------ */
      // TODO : You can check data in here >> console.log('Default Ads', data);
      return null;
  }
};

export default DynamicAds;
